var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"},[_c('statistics-card-line',{attrs:{"icon":_vm.cardIcon,"cardHeader":_vm.cardHeader,"icon-right":"","statistic":_vm.cardValueParsed,"statisticTitle":_vm.cardTitle,"helpCardText":_vm.modalText,"statisticDiff":_vm.statsDiff,"type":"area","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }